if(window.innerWidth > 960) {

    let map = document.querySelector('.free-map__map');
    let tooltip = document.querySelector('.free-map__tooltip');

    if (map) {
        map.addEventListener('mousemove', function (e) {
            let bounds = map.getBoundingClientRect();
            
            tooltip.style.top = e.clientY - bounds.top + 'px';
            tooltip.style.left = e.clientX - bounds.left + 'px'; 
        });
    }

    // Au hover sur les différentes villes (SVG)
    let citiesMap = document.querySelectorAll('.free-map__map svg a'); // on sélectionne dans le DOM toutes les villes contenues dans le SVG

    if (citiesMap) {
        citiesMap.forEach(city => { // on itère sur le tableau citiesMap
            city.addEventListener('mouseover', (event) => { // à chaque SVG de ville survolé
                tooltip.classList.add('active');
                tooltip.append(city.getAttribute('data-title'));
            });

            city.addEventListener('mouseout', (event) => { // si on ne survole plus la ville en question            
                tooltip.classList.remove('active');
                tooltip.innerHTML = "";
            });
        });
    }
}
